import React, { useEffect } from 'react';
import AnimatedCounter from './AnimatedCounter';

const RecipeDetails = ({ recipe }) => {
	// Handle REWE order functionality
	const handleReweOrder = () => {
		// Hardcoded search for "Weißbrot"
		const reweUrl = `https://www.rewe.de/suche/uebersicht?searchTerm=${encodeURIComponent('Weißbrot')}`;

		// Open REWE shop in new tab
		window.open(reweUrl, '_blank', 'noopener,noreferrer');
	};

	// Generate Schema.org Recipe JSON-LD
	const generateRecipeSchema = (recipe) => {
		return {
			'@context': 'https://schema.org',
			'@type': 'Recipe',
			name: recipe.name,
			description: recipe.description,
			image: recipe.image,
			prepTime: recipe.prepTime,
			cookTime: recipe.cookTime,
			totalTime: recipe.totalTime,
			recipeYield: recipe.recipeYield,
			recipeCategory: recipe.recipeCategory,
			recipeCuisine: recipe.recipeCuisine,
			author: {
				'@type': 'Organization',
				name: 'Thankwich',
			},
			recipeIngredient: recipe.ingredients,
			recipeInstructions: recipe.instructions.map((instruction, index) => ({
				'@type': 'HowToStep',
				position: index + 1,
				text: instruction,
			})),
			nutrition: {
				'@type': 'NutritionInformation',
				calories: recipe.nutrition.calories,
				proteinContent: recipe.nutrition.protein,
				carbohydrateContent: recipe.nutrition.carbs,
				fatContent: recipe.nutrition.fat,
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: recipe.rating,
				ratingCount: Math.floor(Math.random() * 50) + 10,
			},
		};
	};

	useEffect(() => {
		// Add Schema.org markup to head
		const schemaScript = document.createElement('script');
		schemaScript.type = 'application/ld+json';
		schemaScript.textContent = JSON.stringify(generateRecipeSchema(recipe));
		document.head.appendChild(schemaScript);

		// Cleanup function to remove the script when component unmounts
		return () => {
			const existingScript = document.querySelector('script[type="application/ld+json"]:last-of-type');
			if (existingScript) {
				document.head.removeChild(existingScript);
			}
		};
	}, [recipe]);

	return (
		<div className="recipe-details show my-5">
			<div className="container">
				<div className="row mb-5">
					<div className="col-12">
						<h5 className="fw-bold mb-3">Die Geschichte des {recipe.name}</h5>
						<p className="lead">{recipe.history}</p>
					</div>
				</div>
				<div className="row bg-light p-4 rounded">
					<div className="col-lg-6 mb-5 mb-lg-0">
						<h5 className="fw-bold mb-3">Zutaten:</h5>
						<ul className="list-unstyled">
							{recipe.ingredients.map((ingredient, index) => (
								<li key={index}>{ingredient}</li>
							))}
						</ul>
						<div className="mt-4">
							<button className="btn btn-primary btn-sm" onClick={handleReweOrder}>
								<i className="bi bi-cart-plus me-2"></i>
								Zutaten bei REWE bestellen
							</button>
						</div>
					</div>
					<div className="col-lg-6">
						<h5 className="fw-bold mb-3">Zubereitung:</h5>
						<ol>
							{recipe.instructions.map((instruction, index) => (
								<li key={index} className="mb-2">
									{instruction}
								</li>
							))}
						</ol>
					</div>
				</div>
				<div className="row mt-5">
					<div className="col-12">
						<h5 className="fw-bold mb-3">Nährwerte:</h5>
						<div className="row">
							<div className="col-3 text-center">
								<AnimatedCounter target={recipe.nutrition.calories} label="Kalorien" duration={1500} />
							</div>
							<div className="col-3 text-center">
								<AnimatedCounter target={recipe.nutrition.protein} label="Protein" duration={1800} />
							</div>
							<div className="col-3 text-center">
								<AnimatedCounter target={recipe.nutrition.carbs} label="Carbs" duration={2000} />
							</div>
							<div className="col-3 text-center">
								<AnimatedCounter target={recipe.nutrition.fat} label="Fett" duration={2200} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RecipeDetails;
